import {createStrokeSVG} from './TEMPLATE'

// tabler: photo
export const Image_Stroke1_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M15 8h.01',
    'M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12',
    'M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5',
    'M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 1.5,
})

// tabler: photo
export const Image_Stroke2_Corner0_Rounded = createStrokeSVG({
  paths: [
    'M15 8h.01',
    'M3 6a3 3 0 0 1 3 -3h12a3 3 0 0 1 3 3v12a3 3 0 0 1 -3 3h-12a3 3 0 0 1 -3 -3v-12',
    'M3 16l5 -5c.928 -.893 2.072 -.893 3 0l5 5',
    'M14 14l1 -1c.928 -.893 2.072 -.893 3 0l3 3',
  ],
  viewBox: '0 0 24 24',
  strokeWidth: 2,
})
